import { Component, Input } from '@angular/core';

import { Blog } from '../../data/models/collections/blog';

@Component({
  selector: 'placeme-blog-card',
  templateUrl: './blog-card.component.html',
  styleUrls: ['./blog-card.component.scss'],
})
export class BlogCardComponent {
  @Input() blog: Blog;
}
